import { createStore } from "vuex";
import general from "@/store/modules/general";
import user from "@/store/modules/user";
import player from "@/store/modules/player";

export default createStore({
    modules: {
        general,
        user,
        player,
    },
});
